import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import styles from '../Favorites.module.scss';
import { MyButton, MyDialog, FormInput } from '@/components';
import { FormProvider, useForm, Controller, SubmitHandler, Control } from 'react-hook-form';
import { CollectionsModel } from '@/types';

interface RenameSelectionModel {
  newFolder: string;
}

export const RenameDialog = ({
  id,
  open,
  name,
  onClose,
  collections,
  renameCollection,
}: {
  id: string;
  open: boolean;
  name: string;
  onClose: () => void;
  renameCollection: (value: string, id: string) => void;
  collections: CollectionsModel[];
}) => {
  const formMethods = useForm<RenameSelectionModel>({});
  const {
    handleSubmit,
    setValue,
    formState: { errors },
    setError,
    clearErrors,
  } = formMethods;

  useEffect(() => {
    setValue('newFolder', name);
  }, []);

  const submitHandler: SubmitHandler<RenameSelectionModel> = async (value) => {
    const collectionsName = collections.map((collection) => collection.collectionName);
    const trimmedNewFolder = value.newFolder?.trim();
    const isDuplicate = trimmedNewFolder && collectionsName.includes(trimmedNewFolder);
    if (isDuplicate) {
      setError('newFolder', {
        type: 'manual',
        message: 'You already have a collection with this name',
      });
      return;
    }
    clearErrors('newFolder');
    renameCollection(value.newFolder, id);
  };

  return (
    <MyDialog open={open} onClose={onClose} dialogTitle='Rename collection' width='600'>
      <FormProvider {...formMethods}>
        <Box component='form'>
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1650FF',
              textAlign: 'center',
              marginBottom: '20px',
            }}
          >
            {name}
          </Typography>
          <Box>
            <FormInput
              uiVariant='blank'
              name='newFolder'
              placeholder='Enter new name'
              label='Enter new name '
            />
          </Box>
          <Box className={styles.submitButtons}>
            <MyButton
              data={{
                buttonName: 'Save',
                customWidth: '226px',
                variant: 'contained',
                buttonType: 'button',
              }}
              onClick={handleSubmit(submitHandler)}
            />
            <MyButton
              data={{
                buttonName: 'Cancel',
                customWidth: '226px',
                styleType: 'cancel',
                variant: 'outlined',
                buttonType: 'button',
              }}
              onClick={onClose}
            />
          </Box>
        </Box>
      </FormProvider>
    </MyDialog>
  );
};
